import type { I18nDict } from '../types.ts'

export const pl: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Ustawienia',
  section_language: 'Język',
  section_identity: 'Lokalna tożsamość',
  section_updates: 'Aktualizacja aplikacji',
  section_notifications: 'Powiadomienia',
  section_theme: 'Motyw wizualny',
  section_backup: 'Kopia zapasowa czatu',
  section_privacy_network: 'Prywatność sieci',
  section_media: 'Multimedia',
  section_security: 'Bezpieczeństwo i hasło',
  section_exit: 'Zamknij i usuń dane',
  toggle_external_links: 'Odbieraj i wyświetlaj linki zewnętrzne',
  hint_external_links: 'Gdy WYŁ.: brak podglądu linków w czacie i nie można otwierać zewnętrznych URL (ochrona przed śledzeniem IP).',
  toggle_auto_media: 'Automatyczne pobieranie multimediów i dokumentów',
  hint_auto_media: 'Gdy WYŁ.: zdjęcia, filmy i pliki nie są pobierane w tle — dotknij ręcznie w czacie.',
  toggle_require_unlock: 'Hasło przy otwieraniu aplikacji',
  hint_require_unlock: 'Gdy WŁ., hasło główne jest wymagane za każdym razem, gdy otwierasz ZION.',
  toggle_wipe_exit: 'Usuń dane przy zamknięciu',
  hint_wipe_exit: 'Gdy WŁ., zamknięcie aplikacji czyści tymczasową pamięć podręczną RAM i dane sesji.',
  btn_exit: 'Wyjdź',
  btn_delete_all: 'USUŃ WSZYSTKIE DANE',
  btn_lock: 'Zablokuj aplikację',
  btn_back: 'Wstecz',
  warn_disable_password_title: '⚠️ OSTRZEŻENIE',
  warn_disable_password_body: 'Wyłączenie hasła otwarcia oznacza, że każdy z dostępem do Twojego urządzenia może odczytać zaszyfrowane wiadomości. Czy na pewno chcesz kontynuować?',
  warn_delete_all_1: 'Czy na pewno chcesz zniszczyć całą bazę danych? Tej operacji nie można cofnąć.',
  warn_delete_all_2: 'Ostateczne potwierdzenie: wszystkie czaty, klucze prywatne i ustawienia zostaną trwale usunięte.',
  link_blocked: 'Link zewnętrzny zablokowany (ustawienia prywatności).',
  lang_welcome_title: 'Witaj w ZION',
  lang_welcome_sub: 'Wybierz język',
  lang_continue: 'Kontynuuj',
  settings_language_label: 'Język aplikacji',
  auth_unlock_title: 'Odblokuj',
  auth_or_password: '— lub odblokuj hasłem —',
  auth_password_master: 'Hasło główne',
  auth_unlock_btn: 'Odblokuj',
  auth_verifying: 'Weryfikowanie…',
  auth_wrong_password: 'Nieprawidłowe hasło',
  auth_unlocked: 'Odblokowano ✓',
  auth_access_title: 'Dołącz do ZION',
  auth_beta_spots: 'Darmowa beta · wolne miejsca:',
  auth_beta_full: 'Beta pełna ({max} użytkowników). Spróbuj ponownie później.',
  auth_beta_free: 'Darmowa beta · licencja nie jest wymagana',
  auth_or_create: '— lub utwórz nową tożsamość —',
  auth_password_min: 'Hasło (min. 8 znaków)',
  auth_password_confirm: 'Potwierdź hasło',
  auth_privacy_check: 'Przeczytałem',
  auth_privacy_link: 'Politykę prywatności',
  auth_terms_check: 'Akceptuję',
  auth_terms_link: 'Regulamin',
  auth_password_local_hint: 'Hasło nigdy nie opuszcza tego urządzenia. Brak konta serwerowego.',
  auth_create_identity: 'Utwórz tożsamość',
  auth_accept_legal_err: 'Zaakceptuj politykę prywatności i regulamin, aby kontynuować',
  auth_generating_keys: 'Generowanie kluczy i sesji…',
  auth_generating_identity: 'Generowanie anonimowej tożsamości…',
  auth_generating_detail: 'Klucze ECDH · pseudonim · sesja socket · kod ZN-',
  auth_you_are: 'Jesteś',
  auth_daily_suffix_hint: 'Dzienny sufiks zmienia się co UTC dzień. Aby sparować, użyj kodu ZN- na ekranie głównym.',
  auth_enter: 'Wejdź do ZION',
  auth_starting: 'Uruchamianie…',
  auth_restore_title: 'Przywróć kopię zapasową',
  auth_restore_hint: 'Masz już zaszyfrowaną kopię zapasową? Odzyskaj tożsamość, kontakty i czaty (np. po wyczyszczeniu pamięci podręcznej).',
  auth_restore_file: 'Plik kopii zapasowej (.enc / .enc.json)',
  auth_restore_pass: 'Hasło do kopii zapasowej',
  auth_restore_pass_ph: 'Hasło użyte przy eksporcie',
  auth_restore_btn: 'Przywróć kopię zapasową',
  auth_restore_pick_file: 'Wybierz plik kopii zapasowej (.enc lub .enc.json).',
  auth_restore_need_pass: 'Wprowadź hasło.',
  auth_restoring: 'Przywracanie…',
  auth_file_prefix: 'Plik:',
  common_accept: 'Akceptuj',
  common_reject: 'Odrzuć',
  common_cancel: 'Anuluj',
  common_accepting: 'Akceptowanie…',
  common_error: 'Błąd',
  common_loading: 'Ładowanie…',
  common_send: 'Wyślij',
  common_copied: 'Skopiowano ✓',
  common_copy_failed: 'Kopiowanie nie powiodło się',
  common_ok: 'OK',
  common_today: 'Dziś',
  common_yesterday: 'Wczoraj',
  common_sending: 'Wysyłanie…',
  home_zn_midnight_hint: 'Zmienia się o północy UTC (za {h}h {m}m)',
  home_temp_empty: 'Brak czatów czasowych. Dotknij ⏱ przy kontakcie, aby rozpocząć.',
  home_unread_aria: '{count} wiadomości',
  home_temp_waiting: 'Oczekiwanie na akceptację…',
  home_temp_expires: 'Czat czasowy · wygasa za {remaining}',
  home_temp_cancel: 'Anuluj',
  home_temp_fallback_label: 'czat czasowy',
  home_temp_invite_title: '⏱ Zaproszenie do czatu czasowego',
  home_temp_invite_body: '{nick} chce tymczasowy czat ({duration}).',
  home_temp_invite_hint: 'Zaakceptuj, aby wymieniać wiadomości, które znikną po wygaśnięciu.',
  home_temp_accept: 'Akceptuj',
  home_temp_reject: 'Odrzuć',
  home_temp_accepting: 'Akceptowanie…',
  home_contacts_empty: 'Brak kontaktów. Udostępnij swój kod ZN- lub QR, aby sparować.',
  home_temp_chat_aria: 'Czat czasowy',
  home_btn_pair_title: 'Parowanie',
  home_btn_settings_title: 'Ustawienia',
  home_zn_title: 'Dzisiejszy kod ZN-',
  home_btn_copy_zn: 'Kopiuj ZN-',
  home_btn_open_pair: 'QR parowania',
  home_section_temp: 'Czaty czasowe',
  home_section_chat: 'Czaty',
  home_loading: 'Ładowanie…',
  home_pair_zn_title: 'Paruj kodem ZN-',
  home_btn_zn_pair: 'Wyślij prośbę',
  home_copied: 'Skopiowano ✓',
  home_copy_failed: 'Kopiowanie nie powiodło się',
  home_pair_request_title: 'Prośba o kontakt',
  home_pair_request_body: '{name} chce rozmawiać.',
  home_pair_reject: 'Odrzuć',
  home_pair_accept: 'Akceptuj',
  home_pair_accepting: 'Akceptowanie…',
  home_pair_accept_failed: 'Akceptacja nie powiodła się',
  home_zn_digits_err: 'Wprowadź 5 cyfr po ZN-.',
  home_sending: 'Wysyłanie…',
  chat_rename: 'Zmień nazwę',
  chat_rename_matrix: '[ZMIANA NAZWY]',
  chat_rename_title: 'Zmień nazwę kontaktu',
  chat_menu_title: 'Opcje czatu',
  chat_loading: 'Ładowanie wiadomości…',
  chat_reply_to: 'Odpowiedz do',
  chat_cancel_title: 'Anuluj',
  chat_voice_lock_hint: 'Przesuń w górę, aby zablokować nagrywanie',
  chat_voice_locked: 'Nagrywanie zablokowane — dotknij Gotowe',
  chat_voice_stop: 'GOTOWE',
  chat_voice_stop_title: 'Gotowe',
  chat_voice_preview_label: 'Podgląd głosu — odsłuchaj przed wysłaniem',
  chat_voice_send: 'WYŚLIJ',
  chat_voice_send_title: 'Wyślij',
  chat_timer_label: 'Timer',
  chat_timer_title: 'Timer wiadomości',
  chat_timer_off: 'WYŁ.',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Zdjęcie',
  chat_photo_title: 'Zdjęcie',
  chat_voice_hold: 'Przytrzymaj, aby nagrywać',
  chat_voice_hold_title: 'Przytrzymaj, aby nagrywać',
  chat_doc: 'Dok',
  chat_doc_title: 'Dokument',
  chat_attach_title: 'Załączniki',
  chat_input_placeholder: 'Wiadomość E2E zaszyfrowana…',
  chat_send: 'Wyślij',
  chat_rename_modal_title: 'Zmień nazwę kontaktu',
  chat_rename_nickname: 'Pseudonim: @{nick}',
  chat_rename_placeholder: 'Własna nazwa',
  chat_rename_cancel: 'Anuluj',
  chat_rename_save: 'Zapisz',
  chat_action_reply: '↩ Odpowiedz',
  chat_action_copy: '⎘ Kopiuj',
  chat_action_delete_me: '🗑 Usuń dla mnie',
  chat_action_delete_all: '🗑 Usuń dla wszystkich',
  chat_action_cancel: 'Anuluj',
  chat_menu_clear_me: '🗑 Wyczyść czat (tylko dla mnie)',
  chat_menu_clear_all: '🗑 Usuń czat dla wszystkich',
  chat_menu_cancel: 'Anuluj',
  chat_doc_send_title: 'Wyślij dokument',
  chat_doc_default_name: 'dokument',
  chat_doc_send_hint: 'Plik zostanie skompresowany, zaszyfrowany E2E i wysłany. Maks. 5 MB.',
  chat_doc_cancel: 'Anuluj',
  chat_doc_send_encrypted: 'Wyślij zaszyfrowany',
  chat_doc_too_large: '⚠️ PLIK ZA DUŻY: Maksymalny limit bezpieczeństwa dla dokumentów to 5 MB.',
  chat_doc_unsupported: 'Nieobsługiwany typ dokumentu.',
  chat_copy_failed: 'Kopiowanie nie powiodło się',
  chat_confirm_delete_me: 'Usunąć tę wiadomość tylko dla Ciebie?',
  chat_confirm_delete_all: 'Usunąć tę wiadomość dla wszystkich?',
  chat_confirm_clear_all: 'Usunąć cały czat dla wszystkich? Tej operacji nie można cofnąć.',
  chat_confirm_clear_me: 'Wyczyścić czat tylko dla Ciebie?',
  chat_jump_new: '↓ Nowe wiadomości',
  chat_empty: 'Brak wiadomości. Napisz coś, aby rozpocząć.',
  chat_voice_err_short: 'Wiadomość głosowa za krótka (minimum 1 sekunda).',
  chat_voice_err_long: 'Wiadomość głosowa za długa (maksimum 2 minuty).',
  chat_voice_err_large: 'Wiadomość głosowa za duża (maks. 3 MB).',
  chat_voice_err_start: 'Nie można rozpocząć nagrywania głosu.',
  chat_destroyed: '✉ Wiadomość odczytana i zniszczona',
  chat_destroyed_title: 'Wiadomość odczytana i zniszczona',
  chat_hold_options: 'Przytrzymaj, aby zobaczyć opcje',
  chat_reply_fallback: 'Wiadomość',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'Kod ZN- zmienia się o północy UTC (za {h}h {m}m).',
  pair_copied: 'Skopiowano ✓',
  pair_copy_failed: 'Kopiowanie nie powiodło się',
  pair_title: 'Parowanie',
  pair_zn_title: 'Twój kod ZN- na dziś',
  pair_btn_copy_zn: 'Kopiuj kod ZN-',
  pair_tab_mine: 'Mój QR',
  pair_tab_scan: 'Skanuj / ZN-',
  pair_qr_aria: 'QR parowania',
  pair_expires_in: 'Wygasa za',
  pair_btn_copy_payload: 'Kopiuj payload',
  pair_btn_regen_qr: 'Wygeneruj nowy QR',
  pair_qr_hint: 'Pokaż ten QR drugiemu urządzeniu. Ważny 10 minut — kompatybilny z aplikacją Android.',
  pair_expired: 'wygasły',
  pair_contact_zn_title: 'Kod ZN- kontaktu',
  pair_zn_prefix_hint: 'Prefiks <strong>ZN-</strong> jest już ustawiony — wprowadź tylko 5 liter/cyfr.',
  pair_btn_zn_request: 'Wyślij prośbę ZN-',
  pair_paste_title: 'Lub wklej QR ZION1::',
  pair_paste_hint: 'Wklej payload <code>ZION1::</code> lub prześlij zdjęcie kodu QR.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Ze zdjęcia / aparatu',
  pair_btn_connect_qr: 'Połącz przez QR',
  pair_zn_digits_err: 'Wprowadź 5 cyfr po ZN-.',
  pair_sending: 'Wysyłanie prośby…',
  pair_reading_qr: 'Odczytywanie QR…',
  pair_qr_not_found: 'Nie znaleziono kodu QR na obrazie.',
  pair_zn_read_ok: 'Kod ZN- odczytany — potwierdź opcją Wyślij prośbę.',
  pair_qr_read_ok: 'QR odczytany — potwierdź opcją Połącz przez QR.',
  pair_qr_read_err: 'Błąd odczytu QR.',
  settings_identity_hint: 'Hasło i klucze pozostają w tej przeglądarce. Brak konta serwerowego.',
  settings_btn_add_home: 'Instrukcja dodania do ekranu głównego',
  settings_devices_title: 'Połączone urządzenia',
  settings_devices_hint: 'Multi-device Zero-Knowledge: klucze podróżują zaszyfrowane E2E. Serwer jest tylko przekaźnikiem.',
  settings_btn_link_device: 'Połącz nowe urządzenie',
  settings_btn_sync_pc: 'Synchronizuj historię PC',
  settings_no_devices: 'Brak połączonych urządzeń.',
  settings_device_self: 'to urządzenie',
  settings_version_prefix: 'Wersja:',
  settings_ios_push_hint: '<strong>iPhone:</strong> powiadomienia = PWA z ekranu głównego + Baner/Dźwięk WŁ. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Wymuś aktualizację aplikacji',
  settings_updating: 'Aktualizowanie…',
  settings_push_mode_prefix: 'Tryb:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> powiadomienia działają tylko przy otwieraniu ZION z ikony ekranu głównego (Udostępnij → Dodaj do ekranu początkowego). W zwykłym Safari <em>nie są</em> dostępne — nawet na iOS 17. Po instalacji na ekranie głównym wróć tutaj i dotknij Włącz powiadomienia.',
  settings_btn_enable_push: 'Włącz powiadomienia push',
  settings_btn_desktop_notify: 'Powiadomienia pulpitu (PC)',
  settings_btn_disable_push: 'Wyłącz powiadomienia',
  settings_desktop_requesting: 'Żądanie uprawnień pulpitu…',
  settings_desktop_ok: 'Powiadomienia pulpitu aktywne (dźwięk + wyskakujące okno przy nowej wiadomości).',
  settings_desktop_denied: 'Uprawnienie odrzucone lub nieobsługiwane.',
  settings_push_no_session: 'Sesja nie jest gotowa.',
  settings_push_requesting: 'Żądanie uprawnień…',
  settings_push_active: 'Powiadomienia aktywne.',
  settings_push_disabled: 'Powiadomienia wyłączone.',
  settings_theme_hint: 'Te same motywy co w aplikacji ZION na Androida.',
  settings_theme_recommended: 'Zalecany',
  settings_backup_hint: 'Plik JSON zaszyfrowany hasłem (zgodny z formatem Android v2). Zapisz na PC: kontakty, czaty i tożsamość web.',
  settings_backup_pass_label: 'Hasło do kopii zapasowej',
  settings_backup_pass_ph: 'Dedykowane hasło (min. 8 znaków)',
  settings_btn_export_backup: 'Eksportuj kopię zapasową',
  settings_backup_file_label: 'Przywróć z pliku',
  settings_backup_import_pass_label: 'Hasło do kopii zapasowej',
  settings_backup_import_pass_ph: 'Hasło użyte przy eksporcie',
  settings_btn_import_backup: 'Przywróć kopię zapasową',
  settings_backup_file_prefix: 'Plik: {name}',
  settings_backup_pass_min: 'Hasło musi mieć co najmniej 8 znaków.',
  settings_backup_creating: 'Tworzenie kopii zapasowej…',
  settings_backup_pick_file: 'Wybierz plik kopii zapasowej (.enc lub .enc.json).',
  settings_backup_need_pass: 'Wprowadź hasło do kopii zapasowej.',
  settings_backup_restoring: 'Przywracanie…',
  settings_backup_overwrite_confirm: 'Nadpisać dane lokalne?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 minut',
  temp_duration_10m: '10 minut',
  temp_duration_15m: '15 minut',
  temp_duration_30m: '30 minut',
  temp_duration_1h: '1 godzina',
  temp_duration_6h: '6 godzin',
  temp_duration_24h: '24 godziny',
  temp_duration_7d: '7 dni',
  temp_remaining_expired: 'Wygasło',
  temp_remaining_days: '{days}d {hours}h',
  temp_remaining_hours: '{hours}h {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Czat czasowy · wiadomości tymczasowe',
  temp_empty: 'Brak wiadomości tymczasowych.',
  temp_empty_hint: 'Napisz wiadomość tymczasową. Zniknie po wygaśnięciu timera.',
  temp_input_placeholder: 'Wiadomość tymczasowa…',
  temp_send: 'Wyślij',
  temp_waiting_accept: 'Oczekiwanie, aż {name} zaakceptuje czat czasowy…',
  temp_waiting_placeholder: 'Oczekiwanie na akceptację…',
  temp_expires_in: 'Wygasa za {remaining}',
  temp_duration_title: 'Czat czasowy',
  temp_duration_with: 'Z {name}',
  temp_duration_hint: 'Wybierz czas trwania — czat zniknie z obu urządzeń.',
  temp_sending_invite: 'Wysyłanie zaproszenia…',
  voice_lock_hint: 'Przesuń w górę, aby zablokować nagrywanie',
  voice_locked: 'Nagrywanie zablokowane — dotknij Gotowe',
  add_home_title: 'Dodaj do ekranu głównego (iPhone / iPad)',
  add_home_guide_title: 'Instrukcja Safari',
  add_home_step1: 'Otwórz <strong>Safari</strong> na tej stronie (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Dotknij <strong>Udostępnij</strong> (kwadrat ze strzałką w górę)',
  add_home_step3: 'Wybierz <strong>Dodaj do ekranu początkowego</strong>',
  add_home_step4: 'Otwórz ZION z <strong>ikony</strong> — nie z karty Safari',
  add_home_hint: 'Na iOS/iPadOS 16.4+ aplikacja na ekranie głównym obsługuje powiadomienia Web Push i klawiaturę czatu. Po instalacji przejdź do <strong>Ustawienia → Włącz powiadomienia</strong>.',
  add_home_btn_continue: 'Rozumiem — kontynuuj',
  add_home_btn_skip: 'Pomiń na razie',
  search_title: 'Szukaj kodem ZN-',
  search_label: 'Dzienny kod ZN-',
  search_placeholder: 'ZN-123456',
  search_btn: 'Szukaj',
  search_hint: 'Wprowadź kod ZN- kontaktu. Brak wyszukiwania po pseudonimie — tożsamość jest tylko lokalna.',
  search_format_err: 'Format: ZN-123456',
  search_resolving: 'Rozwiązywanie kodu…',
  search_invalid_code: 'Nieprawidłowy kod — poproś o zaktualizowany ZN- (ponownie otwórz ZION na urządzeniu drugiej osoby)',
  search_session_found: 'sesja znaleziona',
  search_tap_to_send: 'Dotknij, aby wysłać prośbę',
  search_socket_not_ready: 'Sesja socket nie jest gotowa',
  search_request_sent: 'Prośba wysłana ✓',
  search_request_failed: 'Wysyłanie nie powiodło się',
  license_title: 'Aktywacja licencji Web / iPhone',
  license_heading: 'Licencja',
  license_heading_updated: 'Zaktualizowane warunki',
  license_hint: 'Wprowadź kod <strong>ZION-XXXX-XXXX-XXXX</strong> zakupiony na zionyx.ch. Zostanie powiązany z tą przeglądarką (klucz lokalny).',
  license_code_label: 'Kod licencji',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Aktywuj licencję',
  license_beta_hint: 'Beta web: użyj dedykowanej licencji iPhone, jeśli dostępna.',
  license_accept_legal_err: 'Zaakceptuj politykę prywatności i regulamin, aby kontynuować',
  license_need_code: 'Wprowadź kod licencji',
  license_verifying: 'Weryfikowanie licencji…',
  license_invalid_or_used: 'Nieprawidłowa licencja lub już użyta na innym urządzeniu',
  license_active: 'Licencja aktywna ✓',
  license_err_not_found: 'Nieprawidłowy kod licencji',
  license_err_conflict: 'Licencja już powiązana z innym urządzeniem',
  license_err_rate_limit: 'Zbyt wiele prób — poczekaj minutę',
  license_err_generic: 'Błąd licencji',
  link_device_title: 'Połącz nowe urządzenie',
  link_device_hint: 'Na <strong>PC</strong> otwórz Ustawienia → Połącz nowe urządzenie: zobaczysz <strong>zielony QR</strong>. Następnie zeskanuj go poniżej (aparat lub zdjęcie).',
  link_device_status_ready: '[GOTOWE]',
  link_device_upload_label: 'Prześlij zdjęcie QR',
  link_device_btn_camera: 'Otwórz aparat / galerię',
  link_device_placeholder: 'Link QR lub payload…',
  link_device_btn_send_vault: 'Wyślij zaszyfrowany sejf',
  link_device_err_invalid_qr: 'Nieprawidłowy lub wygasły QR.',
  link_device_status_invalid: '[NIEPRAWIDŁOWY QR]',
  link_device_status_sync_complete: '[SYNCHRONIZACJA ZAKOŃCZONA]',
  link_device_status_transfer_failed: '[TRANSFER NIEUDANY]',
  link_device_status_qr_detected: '[WYKRYTO QR — PRZESYŁANIE...]',
  link_device_status_tap_camera: '[DOTKNIJ ZIELONEGO PRZYCISKU — APARAT IPHONE]',
  link_device_status_use_camera_below: '[UŻYJ APARATU / GALERII PONIŻEJ]',
  link_device_status_point_camera: '[SKIERUJ APARAT NA QR PC...]',
  link_device_status_decoding: '[DEKODOWANIE QR...]',
  link_device_status_qr_not_found: '[NIE ZNALEZIONO QR]',
  link_device_status_decode_failed: '[DEKODOWANIE NIEUDANE]',
  link_device_status_opened_from_qr: '[OTWARTO Z QR — URUCHAMIANIE...]',
  link_recv_title: 'Połącz z telefonu',
  link_recv_hint_compact:
    'Zeskanuj ten <strong>zielony QR</strong> telefonem (Ustawienia → Połącz nowe urządzenie). Magazyn jest szyfrowany end-to-end.',
  link_recv_hint_auth:
    'Masz już ZION na telefonie? Zeskanuj ten QR <strong>Aparatem</strong> — PC połączy się i zaloguje automatycznie.',
  link_recv_qr_alt: 'QR łączenia urządzenia',
  link_recv_copy_link: 'Kopiuj link',
  link_recv_awaiting: '[OCZEKIWANIE NA SKAN TELEFONU — TUNEL OTWARTY...]',
  link_recv_failed: '[PAROWANIE NIEUDANE]',
  link_recv_tunnel_lost:
    'Tunel przerwany — vault może być jeszcze w drodze. Spróbuj ponownie zeskanować QR.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Nowa zaszyfrowana wiadomość',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Wiadomość tymczasowa',
  force_update_title: '🚨 OBOWIĄZKOWA KRYTYCZNA AKTUALIZACJA — Aby nadal bezpiecznie korzystać z Zionyx, musisz pobrać najnowszą wersję.',
  force_update_desc: 'Zainstalowany klient nie jest zgodny z minimalną wersją aktywną na serwerze.',
  force_update_versions: 'Zainstalowana: v{current} · Wymagana: v{required}',
  force_update_btn: 'AKTUALIZUJ TERAZ',
}
